import { render, staticRenderFns } from "./ComparatorJson.vue?vue&type=template&id=76e1e357&scoped=true"
import script from "./ComparatorJson.vue?vue&type=script&lang=js"
export * from "./ComparatorJson.vue?vue&type=script&lang=js"
import style0 from "./ComparatorJson.vue?vue&type=style&index=0&id=76e1e357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e1e357",
  null
  
)

export default component.exports